export const experienceData = [
    {
        id: 1,
        company: 'Oculin Tech BD LTD',
        jobtitle: 'IT Intern',
        startYear: 'Oct,2019',
        endYear: 'Jan,2020'
    },
    {
        id: 2,
        company: 'Upscale IT Solutions',
        jobtitle: 'Junior Frontend Developer',
        startYear: 'Dec,2020',
        endYear: 'June,2021'
    },
    {
        id: 3,
        company: 'Agile in Education USA',
        jobtitle: 'Web Developer',
        startYear: 'Nov,2021',
        endYear: 'Aug,2022'
    },
    
]